<script module lang="ts">
    interface RichTextProps {
    blok: {
      body: any;
    };
  }
</script>


<script lang="ts">
  import { css } from "@agapi/ui/panda/css";
  import { richTextStyles } from "./rich-text.styles";
  import { renderRichText } from "@storyblok/svelte";
  const { blok }: RichTextProps = $props();
  const articleHTML = $derived(renderRichText(blok.body, {
    resolver: (component, blok) => {
          switch (component) {
            case "table":
              return `<table class="rich-text-table">
                  <thead>
                    <tr>
                    ${blok.content.thead.map((th: any) => {
                return (`<th>${th.value}</th>`);
              })}
                    </tr>
                    </thead>
                    <tbody>
                    ${blok.content.tbody.map((tr: any) => {
                return (`<tr>
                       ${tr.body.map((td: any) => {
                  return (`<td>${td.value}</td>`);
                })}
                       </tr>`);
              })}
                  </tbody>
                </table>`;
          }
        }
  }));
</script>

<div class={css(richTextStyles)}>{@html articleHTML}</div>

